/** @file New-socket row: parent bone and second grip; a 24 px axis along the bone, refined in the viewport. */
import { useState } from 'react';
import { Button } from '../../ui-kit/Button';
import { Checkbox } from '../../ui-kit/Checkbox';
import { Select } from '../../ui-kit/Select';
import { boneOptions } from '../rigKit/boneOptions';
import { freshName } from '../rigKit/freshName';
import type { RigView } from '../rigKit/rigView';

/** socket.create { name, parentBone, a: [0, 0], b: [24, 0], grip2 }; the name is unique among bones and sockets (ruling E6-6). */
export function SocketCreate({ doc, t, run }: Pick<RigView, 'doc' | 't' | 'run'>) {
  const parents = boneOptions(doc, (b) => b.kind === undefined);
  const [parentBone, setParentBone] = useState(parents[0]?.value ?? '');
  const [grip2, setGrip2] = useState(false);
  const create = (): void => {
    const taken = [...Object.values(doc.bones), ...Object.values(doc.sockets)].map((e) => e.name);
    run([{ name: 'socket.create', input: { name: freshName('socket', taken), parentBone, a: [0, 0], b: [24, 0], grip2 } }]);
  };
  return (
    <fieldset className="rig-fields">
      <legend>{t('panels.sockets.create')}</legend>
      <Select label={t('panels.sockets.parentBone')} value={parentBone} options={parents} onChange={setParentBone} />
      <Checkbox label={t('panels.sockets.grip2')} checked={grip2} onChange={setGrip2} />
      <Button label={t('panels.sockets.create')} primary disabled={parentBone === ''} onClick={create} />
    </fieldset>
  );
}
